(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hp_footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var footers = document.querySelectorAll('.hp-footer-section');
    if (!footers.length) return;
    var mq = window.matchMedia('(max-width: 749px)');
    footers.forEach(function (footer) {
      footer.querySelectorAll('.hp-footer__col--menu').forEach(function (col) {
        var heading = col.querySelector('.hp-footer__heading');
        if (!heading) return;
        heading.addEventListener('click', function () {
          if (!mq.matches) return;
          col.classList.toggle('is-open');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_page_financing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.hp-fin');
    if (!root) return;

    const amountInput = root.querySelector('#hpf-amount');
    const slider = root.querySelector('#hpf-slider');
    const results = root.querySelectorAll('.hp-fin__calc-result');

    function formatMoney(n) {
      return '$' + Math.round(n).toLocaleString('en-US');
    }

    function monthlyPayment(principal, aprPct, months) {
      const r = (aprPct / 100) / 12;
      if (r === 0) return principal / months;
      return (principal * r * Math.pow(1 + r, months)) / (Math.pow(1 + r, months) - 1);
    }

    function update() {
      const amt = Math.max(100, Math.min(50000, parseFloat(amountInput.value) || 0));
      slider.value = Math.min(50000, amt);

      results.forEach(card => {
        const opt = card.dataset.option;
        const payDisp = card.querySelector('[data-pay-display]');
        const totalDisp = card.querySelector('[data-total-display]');
        const statusDisp = card.querySelector('[data-status-display]');

        let pay = 0, total = 0, eligible = true, statusMsg = '';

        if (opt === 'afterpay') {
          if (amt > 4000) { eligible = false; statusMsg = 'Over $4,000 max'; }
          pay = amt / 4; total = amt;
        } else if (opt === 'shoppay4') {
          if (amt < 35) { eligible = false; statusMsg = 'Under $35 min'; }
          if (amt > 30000) { eligible = false; statusMsg = 'Over $30K max'; }
          pay = amt / 4; total = amt;
        } else if (opt === 'shoppay12') {
          if (amt < 35) { eligible = false; statusMsg = 'Under $35 min'; }
          if (amt > 30000) { eligible = false; statusMsg = 'Over $30K max'; }
          pay = monthlyPayment(amt, 15, 12); total = pay * 12;
        } else if (opt === 'affirm24') {
          if (amt < 2000) { eligible = false; statusMsg = 'Under $2K min'; }
          if (amt > 30000) { eligible = false; statusMsg = 'Over $30K max'; }
          pay = monthlyPayment(amt, 15, 24); total = pay * 24;
        }

        payDisp.textContent = formatMoney(pay);
        totalDisp.textContent = formatMoney(total);
        statusDisp.textContent = statusMsg;
        card.dataset.disabled = !eligible;
      });
    }

    amountInput.addEventListener('input', update);
    slider.addEventListener('input', () => { amountInput.value = slider.value; update(); });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
